import '@hapana/shared/utils/type-defs.util'

/** @type {Styles} */
export const styles = {
  dialogContent: { padding: 4 },
  description: { mb: 3 },
}
